import { defineComponent as _defineComponent } from 'vue'
import { OSkeleton } from '@oruga-ui/oruga'

export interface Props {
  itemClass?: string
  animated?: boolean
  active?: boolean
  circle?: boolean
  height?: number | string
  width?: number | string
  count?: number
  rounded?: boolean
  size?: 'small' | 'medium' | 'large'
  position?: 'centered' | 'left' | 'right'
  noMargin?: boolean
  fullSize?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'NeoSkeleton',
  props: {
    itemClass: null,
    animated: { type: Boolean, default: true },
    active: { type: Boolean, default: true },
    circle: { type: Boolean },
    height: null,
    width: null,
    count: null,
    rounded: { type: Boolean, default: true },
    size: null,
    position: null,
    noMargin: { type: Boolean },
    fullSize: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true,OSkeleton }
}

})